var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.page }, [
    _c(
      "div",
      { class: _vm.$style.container },
      [_c("rbv-loading", { attrs: { label: "Checking, please wait..." } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }